import { useState } from 'react';
import s from '../../styles/notify.module.css';

// Preset flash colours. The sender can also pick a custom one.
const PRESET_COLORS = ['#e03030', '#e0922e', '#e6c52e', '#4a8a6e', '#3a7bd5', '#9b4ddb'];

// Admin/staff form to send a flash notification to one staff member.
// `onSend({ receiver, message, colors })` should return a promise.
export function NotifySendModal({ receiver, onClose, onSend, light }) {
  const [message, setMessage] = useState('');
  const [color, setColor]     = useState(PRESET_COLORS[0]);
  const [sending, setSending] = useState(false);
  const [error, setError]     = useState('');

  const name = `${receiver?.firstName || ''} ${receiver?.lastName || ''}`.trim() || 'staff';

  const handleSend = async () => {
    if (!message.trim() || sending) return;
    setSending(true);
    setError('');
    try {
      await onSend({ receiver: receiver.idUser, message: message.trim(), colors: color });
      onClose();
    } catch (err) {
      setError(err?.message || 'Failed to send notification');
      setSending(false);
    }
  };

  return (
    <div className={`${s.overlay} ${light ? s.light : ''}`} onClick={onClose}>
      <div className={s.notifySendModal} onClick={(e) => e.stopPropagation()}>
        <div className={s.title}>Notify {name}</div>
        <div className={s.subtitle}>Flash notification</div>

        {error && <div className={s.error}>{error}</div>}

        <label className={s.label}>Flash colour</label>
        <div className={s.swatchRow}>
          {PRESET_COLORS.map((c) => (
            <button
              key={c}
              type="button"
              className={`${s.swatch} ${color === c ? s.swatchActive : ''}`}
              style={{ background: c, color: c }}
              onClick={() => setColor(c)}
              aria-label={`Choose ${c}`}
            />
          ))}
          <input
            type="color"
            className={s.colorInput}
            value={color || '#000000'}
            onChange={(e) => setColor(e.target.value)}
            title="Custom colour"
          />
          <button
            type="button"
            className={`${s.swatch} ${s.swatchNone} ${!color ? s.swatchActive : ''}`}
            onClick={() => setColor('')}
            aria-label="No colour — no flash"
            title="No colour — no flash"
          />
        </div>

        <label className={s.label} htmlFor="notifyMessage">Message</label>
        <textarea
          id="notifyMessage"
          className={s.textarea}
          placeholder="What do you want to tell them?"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          autoFocus
        />

        <div className={s.actions}>
          <button className={`${s.btn} ${s.btnCancel}`} onClick={onClose} disabled={sending}>Cancel</button>
          <button className={`${s.btn} ${s.btnPrimary}`} onClick={handleSend} disabled={!message.trim() || sending}>
            {sending ? 'Sending…' : 'Send'}
          </button>
        </div>
      </div>
    </div>
  );
}
